import React from 'react';
import { useAppType } from '../../../../../hooks/useAppType';
import ConsumerDeleteAccountConfirmation from './ConsumerDeleteAccountConfirmation';
import ProDeleteAccountConfirmation from './ProDeleteAccountConfirmation';

export type AccountDeletionConfirmationScreenOwnProps = {};

export type AccountDeletionConfirmationScreenProps = AccountDeletionConfirmationScreenOwnProps;

const AccountDeletionConfirmationScreen: React.FC<AccountDeletionConfirmationScreenProps> = (_props) => {
    const appType = useAppType();

    return appType === 'consumer' ? <ConsumerDeleteAccountConfirmation /> : <ProDeleteAccountConfirmation />;
};

export default React.memo(AccountDeletionConfirmationScreen);
